<template>
  <v-container
      v-if="loaderModel"
      fluid
      fill-height
      grid-list-md
      no-click-animation="true"
      class="OverheadLoaderContainer"
  >
    <v-dialog persistent v-model="loaderModel" width="360" height="270">
      <v-card style="width:360px;height:270px;">
        <v-layout
            column
            fill-height="true"
            align-center="true"
            align-content-center="true"
        >
          <v-flex
              xs10
              d-flex
              grow="true"
              align-self-center="true"
              style="overflow: hidden; align-items: center;"
          >
            <v-progress-circular
                :size="100"
                :width="10"
                indeterminate
                color="primary"
            />
          </v-flex>
          <v-flex
              xs2
              d-flex
              align-self-center="true"
              style="align-items: center; font-weight: 600; font-size: 1.125rem;"
          >
            <span>Loading</span>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {store} from "../main.js"

export default {
  name: "OverheadLoader",
  props: {
    inStructure:Boolean,
  },
  data() {
    return {
      loaderModel: false,
      timer: null
    }
  },
  computed: {
    loading: function () {
      return store.loading;
    }
  },
  watch: {
    loading: function () {
      //Clear timeout in case of rapid changes in state
      try{
        clearTimeout(this.timer)
      } catch (e) {}

      if (!store.loading) {
        //Delay state change to ensure that loader is visible to the user
        this.timer = setTimeout(() => {
          this.loaderModel = store.loading;
        }, 500);
      } else {
        //Open loader immediately
        this.loaderModel = store.loading;
      }
    }
  }
}
</script>

<style scoped>
.OverheadLoaderContainer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;

  height: 100%;
  width: 100%;
}
</style>